import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const DashboardContainer = styled.div`
  height: ${props =>
    props.proPicHeight ? `calc(100% - ${props.proPicHeight}px)` : '100%'};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const DashboardContent = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.countedElements}, auto);
  grid-template-rows: repeat(${props => props.countedElements}, auto);
  gap: ${pxToRem(29)};
`;

export const DashboardRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${pxToRem(29)};
`;

export const DashboardCard = styled.div`
  height: ${pxToRem('267px')};
  width: ${pxToRem('297px')};
  display: flex;
  justify-content: center;
  align-items: center;
  //padding: ${pxToRem('59px')} ${pxToRem('204px')};
  background-image: ${props => props.theme.colors.gradient.dashboardCards};
  backdrop-filter: blur(22px);
  border-radius: ${pxToRem('24px')};
  border: 2px solid rgba(255,255,255,0.52);
  cursor: pointer;
`;

export const DashboardCardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${pxToRem('24rem')};
`;
